import React from 'react';
import styles from './InitiativeMap.module.scss';
import { LocationCard } from './LocationCard/LocationCard';
import { StaticMap } from '../../../../../../../Components/ReportCard/ContactMap/StaticMap/StaticMap';
import { InitiativeArea } from '../../../../../../../Models/InitiativeValue';
import { UseInitiativeMap } from './hooks/UseInitiativeMap';

export interface InitiativeMapProps {
  className?: string;
  areas?: InitiativeArea[];
}

export const InitiativeMap = ({
  className = '',
  areas
}: InitiativeMapProps): React.ReactElement<InitiativeMapProps> => {
  const { locationText, areasPaths, position, zoom } = UseInitiativeMap({
    areas
  });
  return (
    <div className={`${styles.initiativeMap} ${className}`}>
      <div className={styles.mapInfoContainer}>
        <div className={styles.infoWrapper}>
          <LocationCard location={locationText} />
        </div>
      </div>

      <StaticMap areas={areasPaths} position={position} zoom={zoom} />
    </div>
  );
};
